import React, {useContext, useRef, useState} from "react";
import {
  AButton,
  AIcon,
  AListItem,
  AMenu,
  AMount
} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useDispatch} from "react-redux";
import {SavedInvestigationsContext} from "contexts/SavedInvestigationsContext";
// eslint-disable-next-line max-len
import {bulkDeleteSavedInvestigations} from "store/features/savedInvestigationsSlice";
import {download} from "utils/fileUtils";

export const normalizeForFileName = (desc) =>
  desc.replace(" @ ", ".").replace(/[\s:!@"<>*|]/g, "-");

const SavedInvestigationsContextMenu = ({investigation}) => {
  const dispatch = useDispatch();
  const buttonRef = useRef(null);
  const {filterSettings} = useContext(SavedInvestigationsContext);

  const [open, setOpen] = useState(false);

  const downloadJSON = () => {
    // TODO: Verify that private user data obfuscation has been implemented on
    // back end. Otherwise users will need to be filtered before download.
    const filename = normalizeForFileName(investigation.short_description);
    download(filename, investigation);
  };

  const deleteInvestigation = () => {
    dispatch(
      bulkDeleteSavedInvestigations({
        investigations: [investigation],
        filterSettings
      })
    );
  };

  return (
    <AMount
      style={{position: "relative"}}
      data-testid="SavedInvestigationsContextMenu">
      <AButton
        tertiaryAlt
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        aria-haspopup="true">
        <AIcon size={20}>dots-three</AIcon>
      </AButton>
      <AMenu
        data-testid="SavedInvestigationsContextMenu-Menu"
        anchorRef={buttonRef}
        open={open}
        placement="bottom-right"
        onClose={() => setOpen(false)}>
        <AListItem onClick={downloadJSON}>
          {t("investigate.savedInvestigations.actions.downloadJson")}
        </AListItem>
        <AListItem
          onClick={deleteInvestigation}
          className="mds-red--red-7--text">
          {t("investigate.savedInvestigations.actions.delete")}
        </AListItem>
      </AMenu>
    </AMount>
  );
};

export default SavedInvestigationsContextMenu;
